import { ActiveLink } from "@/components/layout/active-link/ActiveLink";
import { CheckBoxDtos } from "@/components/ui";
import React from "react";
import { FaEnvelope, FaRegIdCard } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import { ResetPasswordFormProps } from "../Types/types";

const LoginLinks = [
  {
    path: "/login",
    text: "Inicia Sesión",
    title: "Iniciar Sesión",
  },
];

const FormResetPassword: React.FC<ResetPasswordFormProps> = ({
  email,
  emailError,
  onEmailChange,
  onSubmit,
  acceptTerms,
  isCheckboxDisabled,
  tipoDocumento,
  numeroDocumento,
  numeroDocumentoError,
  onTipoDocumentoChange,
  onNumeroDocumentoChange,
  onAcceptTermsChange,
  loading,
  tiposIdentificacion,
  loadingTipos,
}) => {
  const documentosOptions = loadingTipos
    ? [{ value: "", label: "Cargando tipos..." }]
    : tiposIdentificacion.map((tipo) => ({
        value: tipo.nombre,
        label: tipo.nombreCompleto,
      }));

  const areFieldsValid = !isCheckboxDisabled;

  return (
    <form
      key="reset-password-form"
      className="flex flex-col gap-5 form-emerge"
      onSubmit={onSubmit}
    >
      {/* DOCUMENTO */}
      <div className="relative space-y-2 p-0.5">
        <label className="text-lg font-bold block text-black">
          Documento de identificación <span className="text-[var(--color-error)]">*</span>
        </label>

        <div className="relative p-0.5">
          <select
            className="w-full px-3 py-3 pr-10 border rounded-2xl text-xl bg-white focus:outline-none focus:ring-2 transition duration-300 text-gray-600 border-gray-300 focus:ring-blue-400 cursor-pointer appearance-none"
            value={tipoDocumento}
            onChange={onTipoDocumentoChange}
            disabled={loadingTipos}
          >
            <option value="">
              {loadingTipos ? "Cargando..." : "Selecciona tipo"}
            </option>
            {documentosOptions.map((doc) => (
              <option key={doc.value} value={doc.value}>
                {doc.label}
              </option>
            ))}
          </select>
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-xl">
            <FiChevronDown />
          </span>
        </div>

        <div className="relative">
          <div className="flex gap-1">
            <div className="flex-1 relative">
              <input
                title="Número de documento"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="Número de Documento"
                required
                value={numeroDocumento}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, "");
                  onNumeroDocumentoChange({
                    ...e,
                    target: { ...e.target, value: onlyNumbers },
                  } as React.ChangeEvent<HTMLInputElement>);
                }}
                disabled={!tipoDocumento}
                className={`w-full pl-10 pr-4 py-3 border rounded-2xl text-xl bg-white focus:outline-none focus:ring-2 transition duration-300 text-gray-600 ${
                  numeroDocumentoError
                    ? "border-red-500 focus:ring-red-400"
                    : "border-gray-300 focus:ring-blue-400"
                } ${!tipoDocumento ? "bg-gray-100 cursor-not-allowed" : ""}`}
              />
              <FaRegIdCard className="w-5 h-5 absolute left-3 top-1/2 -translate-y-3 text-gray-400 pointer-events-none" />
            </div>
          </div>

          {numeroDocumentoError && (
            <p className="mt-1 text-xs sm:text-sm text-[var(--color-error)] font-medium">
              {numeroDocumentoError}
            </p>
          )}
        </div>
      </div>

      {/* CORREO */}
      <div className="relative p-0.5">
        <label className="text-lg font-bold block text-black">
          Correo electrónico <span className="text-[var(--color-error)]">*</span>
        </label>
        <div className="relative p-0.5">
          <input
            title="Correo"
            type="email"
            placeholder="tucorreo@mail.com"
            required
            value={email}
            onChange={onEmailChange}
            className={`w-full pl-12 pr-4 py-3 border rounded-2xl text-xl bg-white focus:outline-none focus:ring-2 transition duration-300 text-gray-600 ${
              emailError
                ? "border-red-500 focus:ring-red-400"
                : "border-gray-300 focus:ring-blue-400"
            }`}
          />
          <FaEnvelope className="w-6 h-6 absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
        </div>
        {emailError && (
          <p className="mt-1 text-xs sm:text-sm text-[var(--color-error)] font-medium">
            {emailError}
          </p>
        )}
      </div>

      <div className="flex flex-col gap-2 mt-2">
        <div className="flex items-center gap-2">
          <CheckBoxDtos
            checked={acceptTerms}
            disabled={isCheckboxDisabled}
            onChange={onAcceptTermsChange}
            required={true}
          />
        </div>

        <div className="text-center text-base font-medium opacity-90 text-[var(--color-primary)]">
          <ActiveLink
            key={LoginLinks[0].path}
            path={LoginLinks[0].path}
            text={LoginLinks[0].text}
            title={LoginLinks[0].title}
          />
        </div>
      </div>

      {/* BOTÓN */}
      <button
        type="submit"
        disabled={!acceptTerms || !areFieldsValid || loading}
        className={`w-full py-3 sm:py-5 font-bold rounded-2xl text-xl transition duration-300 shadow-md ${
          acceptTerms && areFieldsValid && !loading
            ? "bg-[var(--color-primary)] text-white hover:bg-[var(--color-primary-600)] hover:shadow-lg shadow-blue-400/30 cursor-pointer"
            : "bg-gray-300 text-gray-500 cursor-not-allowed shadow-gray-300/30"
        }`}
      >
        {loading ? "Enviando..." : "Restaurar Contraseña"}
      </button>
    </form>
  );
};

export default FormResetPassword;
